/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const addPlaceholderManagement = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER_MANAGEMENT.POST}`, payload);
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const getSupplier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTier1Supplier = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_T1}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getAllTierSupplier = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_ALL_TIER}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductSupplier = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_PRODUCTSUPPLIER}`, { params: { ...id } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTier2HigherSupplier = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_T2_HIGHER}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getFactorySupplier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_FACTORY_SUPPLIERS}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addSupplier = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.POST}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editSupplier = async (id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.PUT}${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSingleSupplierById = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_SINGLE_SUPPLIER}${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSupplierActiveState = async (id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.ACTIVE_STATE}${id}/active-state`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const supplierSuggestSwitch = async (id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.SUGGEST_SWITCH}${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const integrateSupplier = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.INTEGRATE_SUPPLIER}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSupplier = async (id, userID) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPLIER.DELETE}${id}`, {
      params: userID,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addSupplierUser = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_USER.POST}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierUserById = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_USER.GET}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editSupplierUserById = async (id, payload) => {
  console.log('Service Payload==========', payload);
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_USER.PUT}${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSupplierUserById = async (id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_USER.DELETE}${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSupplierUserStatusById = async (id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_USER.UPDATE_STATUS}${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultiUser = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_USER.MULTIDELETE_USER}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getComponentSupplier = async (id, data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_SUPPLIER.GET}${id}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addComponentSupplier = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COMPONENT_SUPPLIER.POST}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editComponentSupplier = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COMPONENT_SUPPLIER.PUT}${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteComponentSupplier = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COMPONENT_SUPPLIER.DELETE}`, { data: id });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSingleFactoryById = async (id, supplierId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_SUPPLIER.GET_SINGLE_FACTORY}${id}`, { params: { supplierId } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// user mangment service method start
export const getRightsAssignment = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.RIGHTS_ASSIGNMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUserRightsAssignment = async (data) => {
  try {
    console.log('add RightsAssignment ', data);
    return await apiClient.post(`${apiEndpoint}${API.USER_MANAGEMENT.RIGHTS_ASSIGNMENT}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllBrands = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.GET_MASTERS_BRANDS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllCategory = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_1}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// user mangment service method start
export const setUserPassword = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_USER.SET_PASSWORD}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Bom Due Date

export const getAllBomDueDate = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_DUE_DATE.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addBomDueDate = async (params) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_DUE_DATE.POST}`, params);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteBomDueDate = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_DUE_DATE.DELETE}`, {
      data: params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// supplier document upload service method start

export const getAllDocuments = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.SUPPLIER_DOC}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadSupplierDocument = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.SUPPLIER_DOC}?section=supplierOverview&action=addEdit`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDocument = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.SUPPLIER_DOC}?section=supplierOverview&action=addEdit`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDocuments = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.SUPPLIER_DOC}?section=supplierOverview&action=delete`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const approveRejectDocuments = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.SUPPLIER_DOC_STATUS}?section=supplierOverview&action=addEdit`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const renewDocument = async (data, docId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.RENEW_DOCUMENT}${docId}?section=supplierOverview&action=addEdit`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPendingDocumentType = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_DOCUMENT.PENDING_TYPE_DOCUMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserSuppliers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_USER_SUPPLIERS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierTagData = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.SUPPLIER_TAGS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const registerSupplier = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.REGISTER_SUPPLIER}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkIsLinkExpired = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.CHECK_LINK_EXPIRATION}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkIfEmailIsVerified = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.CHECK_EMAIL_VERIFICATION}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkIsLinkExpiredForUser = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_USER.CHECK_PASS_LINK_EXP}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setPasswordForSupplierUser = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_USER.SET_NEW_PASSWORD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// fetch internal point of contact
export const getUserList = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.SUPPLIER_USERLIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// send submit request for email
export const sendFactoryUpdateLink = async (dataObj) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.SEND_FACTORY_UPDATE}`, dataObj);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const insertSupplierTemplate = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.COMMON_SUPPLIER_TEMPLATE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editSupplierTemplateById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.COMMON_SUPPLIER_TEMPLATE}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierTemplateById = async (id, pageId, supplierId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.SUPPLIER_TEMPLATE}/${id}/${pageId}`, { params: { supplierId } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierTemplates = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.COMMON_SUPPLIER_TEMPLATE}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSupplierDocumentTemplate = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.SAVE_SUPPLIER_DOCUMENT_TEMPLATE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDocTemplate = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.EDIT_SUPPLIER_TEMPLATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierDocTemplates = async (supplierId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.EDIT_SUPPLIER_TEMPLATE}/${supplierId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const archiveUnarchiveDocument = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.ARCHIVE_UNARCHIVE}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllTemplates = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_SUPPLIER_TEMPLATE}`, {
      params: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const markAsComplete = async (paramData) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.IS_COMPLETE}`, {
      ...paramData,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDocumentTemplateByID = async (documentId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.DOCUMENT_TEMPLATE}/${documentId}/${pageId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateDocumnet = async (paramData) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.DUPLICATE_DOCUMENT}`, {
      ...paramData,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePartnerTemplates = async (ids, params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPLIER.COMMON_SUPPLIER_TEMPLATE}`, {
      data: { libIds: ids },
      params: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateTemplate = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.DUPLICATE_TEMPLATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDocTemplatewithDocumentId = async (documentData, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.UPDATE_DOCUMENT}/${id}`, documentData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadTemplate = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.DOWNLOAD_TEMPLATE}`, {
      params: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadSCMImageS3 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.UPLOAD_SCM_IMAGE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSCMImageFromS3 = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPLIER.SCM_IMAGE_DELETE}`, { data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteModuleTemplatePage = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPLIER.DELETE_PAGE_ID}`, {
      data: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPartnerModuleList = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.SUPPLIER_MODULE_LIST}/${id}`, { params: { ...params } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNewPageId = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_NEW_PAGEID}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// pageId Controls
export const getPageControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.PARTNER_MODULE_PAGE_CONTROLS}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
// pageId Controls
export const getSrcPages = async (customModuleLibId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.PARTNER_MODULE_PAGES}/${customModuleLibId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateTemplateSequence = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.TEMPLATE_SEQUENCE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTemplateContentPage = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.TEMPLATE_CONTENT_PAGE}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierTemplateModuleList = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.DOUCUMENT_TEMPLATE_LIST}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// get all depenednt controls
export const getDependentControlsList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.PARTNER_MODULE_DEPENDENT_CONTROLS}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshSupplierTemplate = async (objParam) => {
  try {
    return await apiClient.get(
      `${apiEndpoint}${API.SUPPLIER.REFERESH_TEMPLATE}/${objParam.supplierId}/${objParam.templateId}/${objParam.documentId}/${objParam.pageId}`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshTemplateWithPages = async (objParam) => {
  try {
    return await apiClient.get(
      `${apiEndpoint}${API.SUPPLIER.REFERESH_TEMPLATE_PAGE}/${objParam.supplierId}/${objParam.templateId}/${objParam.documentId}/${objParam.pageId}`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateCopiedPageInLibrary = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER.DUPLICATE_SUPPLIER_FILE_PAGE}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSupplierContentPage = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_SUPPLIER_FILE_CONTENT_PAGE}/${data.id}/${data.supplierId}/${data.templateId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getFactoriesTags = async (supplierId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_SUPPLIER.GET_FACTORY_TAGS}${supplierId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const retrieveDocStatus = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.GET_DOC_STATUS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTierSSupplier = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_TIERS}`, {
      params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// pageId Controls
export const getSupplierPageControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_PARTNER_CALCULATION_PAGE}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getTierSSupplierList = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.TIER_SUPPLIERS_LIST}`, {
      params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Export selected suppliers to Excel
 * @param {string[]} selectedIds - Array of selected supplier IDs
 * @param {string} [tierType] - Tier type (Tier1, Tier2, Tier3, Tier4) - defaults to Tier1
 * @returns {Promise<Blob>} Excel blob response
 */
export const exportSelectedSuppliers = async (selectedIds, tierType = 'Tier1') => {
  try {
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) {
      throw new Error('Selected IDs array is required and must not be empty');
    }

    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.EXPORT_SELECTED}`, { selectedIds, tierType }, { responseType: 'blob' });
  } catch (error) {
    console.error('Error in exportSelectedSuppliers:', error);
    throw error;
  }
};

/**
 * Export all suppliers to Excel with optional filters
 * @param {Object} [params={}] - Query parameters for filtering
 * @param {string} [params.tierType] - Tier type (Tier1, Tier2, Tier3, Tier4)
 * @param {string} [params.searchText] - Search text for filtering
 * @param {string} [params.countryFilter] - Country filter
 * @param {string} [params.supplierTypeFilter] - Supplier type filter (comma-separated IDs)
 * @param {string[]} [params.supplierTagType] - Supplier tag filter (same as suppliers-list)
 * @returns {Promise<Blob>} Excel blob response
 */
export const exportAllSuppliers = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.tierType) queryParams.append('tierType', params.tierType);
    if (params.searchText?.trim()) queryParams.append('searchText', params.searchText.trim());
    if (params.countryFilter) queryParams.append('countryFilter', params.countryFilter);
    if (params.supplierTypeFilter) queryParams.append('supplierTypeFilter', params.supplierTypeFilter);
    const tagTypes = Array.isArray(params.supplierTagType) ? params.supplierTagType : [];
    tagTypes.forEach((tag) => queryParams.append('supplierTagType', tag));
    if (params.customAttributes) queryParams.append('customAttributes', params.customAttributes);

    const fullUrl = `${apiEndpoint}${API.SUPPLIER.EXPORT_ALL}?${queryParams.toString()}`;
    return await apiClient.get(fullUrl, { responseType: 'blob' });
  } catch (error) {
    console.error('Error in exportAllSuppliers:', error);
    throw error;
  }
};

/**
 * Download sample template for supplier upload
 * @param {Object} params - Template parameters
 * @param {string} params.tierType - Tier type (Tier1, Tier2, Tier3, Tier4)
 * @returns {Promise<Blob>} Excel blob response
 */
export const downloadSupplierSampleTemplate = async (params) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.tierType) queryParams.append('tierType', params.tierType);

    const fullUrl = `${apiEndpoint}${API.SUPPLIER.DOWNLOAD_SAMPLE_TEMPLATE}?${queryParams.toString()}`;
    return await apiClient.get(fullUrl, { responseType: 'blob' });
  } catch (error) {
    console.error('Error in downloadSupplierSampleTemplate:', error);
    throw error;
  }
};

export const getSupplierUploadPresignedUrl = async (fileName, tier) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER.UPLOAD_PRESIGNED_URL}`, {
      fileName,
      tier,
    });
  } catch (error) {
    console.error('getSupplierUploadPresignedUrl error:', error);
    throw error;
  }
};

/**
 * Sets a factory's active state.
 * @param {string} factoryId - Factory id.
 * @param {{ supplierId: string, isActive: boolean }} payload - Owning supplier and target state.
 * @returns {Promise} API response.
 */
export const updateFactoryActiveState = async (factoryId, payload) => apiClient.put(`${apiEndpoint}${API.COMPONENT_SUPPLIER.ACTIVE_STATE}${factoryId}/active-state?section=supplierOverview&action=addEdit`, payload);

export const getFactoryActiveStates = async (supplierId) => apiClient.get(`${apiEndpoint}${API.COMPONENT_SUPPLIER.ACTIVE_STATES}`, { params: { supplierId } });
